import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import {TFormState} from '../../../../models/forms.model';
import {CompanyContractModel, ContractWrapperModel} from '../../../../models/contract.model';
import {catchError, EMPTY, filter, Subscription, switchMap, tap} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {AlertService} from '../../../../services/notify/alert.service';
import {MemberModel} from '../../../../models/user.model';
import {DialogsMTService} from '../../../../services/modal/dialogs-mt.service';
import {ContractContextMenuService} from '../../services/contract-context-menu.service';
import {ContractDataService} from '../../services/contract-data.service';
import {ContractFormService} from '../../services/contract-form.service';
import {ContractAvatarsService} from '../../services/contract-avatar.service';
import {IContractDataModel} from '../../models/contract-internal-models';
import {AppAddMemberFormComponentMT} from "../forms/add-member/add-member-form.component";

@Component({
    selector: 'app-contract-parties-block',
    templateUrl: './contract-parties-block.component.html',
    styleUrl: './contract-parties-block.component.scss',
    changeDetection:ChangeDetectionStrategy.OnPush
 
})
export class AppContractPartiesBlockComponent {
    @Input() contractGuid: string = ''
    private contractData: IContractDataModel|undefined = undefined
    public usersList: MemberModel[] = []
    private subs=new Subscription()
    public showDetailedParties:boolean = false
    public formState:TFormState = 'Default'
    public observers:string[] = []
    public signersWithoutProject:string[] = []
    public companies!:CompanyContractModel[]
    public privates!:CompanyContractModel[]
    private selectedGuid:string = ''
    public allParties!:{guid:string,signed:boolean}[]
    public isCurrentMemberInContract:boolean = false
    public hideBlockToUpdate:boolean = false
    constructor(
      public contractDataService:ContractDataService,
      public contractFormService:ContractFormService,
      public contractAvatarsService:ContractAvatarsService,
      private contextMenuService:ContractContextMenuService,
      private dialog:MatDialog,
      private alertService:AlertService,
      private dialogsMTService:DialogsMTService,
      private cds:ChangeDetectorRef
    ) { }
    ngOnDestroy(): void {
      this.subs.unsubscribe()
    }
    ngOnInit(): void {
       this.subs.add(this.contractDataService.bSubContractDataIsCached.asObservable()
       .pipe(filter(data=> data.guid === this.contractGuid))
       .subscribe(data=> {
         this.contractData = this.contractDataService.ContractDataCachedByGuid.get(this.contractGuid)
         this.isCurrentMemberInContract = this.contractData?.rights?.isCurrentMemberInContract||false
         this.contractData?.contract? this.partiesDataChanged(this.contractData?.contract) : null
       } 
      ))
      //delete user
      this.subs.add(this.contextMenuService.subDeleteContextMenu.asObservable()
      .pipe(filter(data=>data.targetContext==='contractParty' && data.contractGuid === this.contractGuid))
      .subscribe(()=>this.onDeleteUserFromMembers()))
      //avatars ready
      this.subs.add(this.contractAvatarsService.bSubAvatarsReady.asObservable()
      .pipe(filter(data=>data===true))
      .subscribe(()=>{
        this.hideBlockToUpdate = true
        this.hideBlockToUpdate = false
        setTimeout(() => {this.cds.detectChanges()}, 100);
      }))
    }
    partiesDataChanged (contract:ContractWrapperModel) {
      this.signersWithoutProject = [...contract?.members_empty_project.filter(el=>el.can_verify===true).map(el=>el.member.guid)]
      this.observers = [...contract?.members_empty_project.filter(el=>el.can_verify===false).map(el=>el.member.guid)]
      this.companies = contract.projects.filter((el:CompanyContractModel)=>el.project.subtype !== 'MEMBER');
      this.privates = contract.projects.filter((el:CompanyContractModel)=>el.project.subtype === 'MEMBER')
      this.allParties = []
      this.allParties = [
        ...this.companies.map(el=>el.members.signatories.map(el=>{return {guid:el.member.guid, signed:!!el.verified_at}})).flat(),
        ...this.companies.map(el=>el.members.observers.map(el=>{return {guid:el.member.guid,signed:false}})).flat(),
        ...contract.privates.map(el=>{return {guid:el.member.guid, signed:!!el.verified_at}}),
        ...contract.members_empty_project.map(el=>{return {guid:el.member.guid, signed:false}}),
      ]
      this.cds.detectChanges()

    }
    onRightClick(e:Event,guid:string) {
      this.selectedGuid = guid
    }
    openAddMemberForm() {
      this.contractFormService.checkInterDomainRedirect(this.contractData?.contract?.contract).subscribe(()=>{
        let formAddUser = this.dialog.open(AppAddMemberFormComponentMT, {
            panelClass: 'add-member-padding-modalbox',
            minWidth: '800px'
        })
        formAddUser.componentInstance.allMembers = this.contractDataService.allMembers;
        formAddUser.componentInstance.guidContract = this.contractGuid;
        formAddUser.componentInstance.isAddSignerBlocked =  this.contractDataService.subContractBlockEdit.value;
        formAddUser.afterClosed()
        .pipe(
            tap(result => this.alertService.setAlert(result.message, result.error ? 'blue' : 'nd_color')),
            filter(result => result?.contract),
            catchError(() => {
                return EMPTY
            })
        )
        .subscribe(() => {
          this.contractAvatarsService.bSubAvatarsReady.next(false)
          this.contractDataService.subContractReloadContract.next(true)
        })
      })
    }
    onDeleteUserFromMembers(): void {
      this.contractFormService.checkInterDomainRedirect(this.contractData?.contract?.contract).subscribe(()=>{
        this.dialogsMTService.confirmDialog({
            actionHeader: 'CONFIRM.HEADERS.ATTENTION',
            actionBody: 'CONFIRM.TEXT.DELETE_MEMBER_CONTRACT'
        }).pipe(
            filter(res => res.isConfirmed),
            switchMap(() => this.contractFormService.deleteMemberFromContract(this.selectedGuid, this.contractGuid)
            .pipe(
              catchError(e => {
                this.alertService.setAlert(e.message, 'blue');
                return EMPTY
              }))),
            catchError(() => {
                return EMPTY
            })
        ).subscribe(res => {
            this.alertService.setAlert(res.message, 'nd_color');
            this.contractDataService.subContractReloadContract.next(true)
        })
      })
    }
}